import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import ServiceExperience from "@/components/ServiceExperience";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import AutomationDemo from "@/components/AutomationDemo";
import VideoAds from "@/components/VideoAds";
import WebsiteShowcase from "@/components/WebsiteShowcase";
import ResultSection from "@/components/ResultSection";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });
    window.__lenis = lenis;

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App relative bg-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <ServiceExperience />
        <WhyUs />
        <Process />
        <AutomationDemo />
        <VideoAds />
        <WebsiteShowcase />
        <ResultSection />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
